import { useTranslation } from "react-i18next";

import { ReturnModalAtomProps } from "../../ReturnModal.types";
import { ReturnModalBlock } from "./ReturnModalBlock";

import styles from "../../ReturnModal.module.scss";

export const ReturnModalPricesBlock = ({
  returnDetails
}: ReturnModalAtomProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.returnModal_prices}>
      <ReturnModalBlock label={t("Earnings breakdown")}>
        <div className={styles.returnModal_earnings}>
          <div className={styles.returnModal_earnings_item}>
            <div className={styles.returnModal_earnings_title}>
              {t("Previous commission")}
            </div>

            <div className={styles.returnModal_earnings_greenText}>
              {returnDetails.oldTotalCommission.toLocaleString("en-US")} FCFA
            </div>
          </div>
          <div className={styles.returnModal_earnings_item}>
            <div className={styles.returnModal_earnings_title}>
              {t("Previous margin")}
            </div>

            <div className={styles.returnModal_earnings_pinkText}>
              {returnDetails.oldTotalMargin.toLocaleString("en-US")} FCFA
            </div>
          </div>
          <div className={styles.returnModal_earnings_item}>
            <div className={styles.returnModal_earnings_title}>
              {t("New commission")}
            </div>

            <div
              className={`${styles.returnModal_earnings_greenText} ${styles.returnModal_earnings_boldText}`}
            >
              {returnDetails.newTotalCommission.toLocaleString("en-US")} FCFA
            </div>
          </div>
          <div className={styles.returnModal_earnings_item}>
            <div className={styles.returnModal_earnings_title}>
              {t("New margin")}
            </div>

            <div
              className={`${styles.returnModal_earnings_pinkText} ${styles.returnModal_earnings_boldText}`}
            >
              {returnDetails.newTotalMargin.toLocaleString("en-US")} FCFA
            </div>
          </div>
        </div>
      </ReturnModalBlock>

      <ReturnModalBlock label={t("Refund Details")}>
        {returnDetails.isReviewFinished ? (
          <div className={styles.returnModal_refundDetails}>
            <div className={styles.returnModal_refundDetails_row}>
              <div className={styles.returnModal_refundDetails_boldText}>
                {t("Refund Total")}
              </div>

              <div
                className={`${styles.returnModal_refundDetails_boldText} ${styles.returnModal_refundDetails_largeText}`}
              >
                {returnDetails.refund
                  ? `${returnDetails.refund?.amount?.toLocaleString("en-US")} FCFA`
                  : "0 FCFA"}
              </div>
            </div>
          </div>
        ) : (
          <p className={styles.returnModal_refundDetails_message}>
            {t(
              "The refund details will be available after the inventory manager has reviewed the return"
            )}
          </p>
        )}
      </ReturnModalBlock>
    </div>
  );
};
